export default __webpack_public_path__ + "static/media/background.4a76e7ca.png";